<template>
    <div>
        <CIcon size="xl" v-if="this.devicetype.devicetype === 'phone' " name="cilMobile" title='Mobile phone'></CIcon>
        <CIcon size="xl" v-if="this.devicetype.devicetype === 'console' " name="cilGamepad"  title='Games console'></CIcon> 
        <CIcon size="xl" v-if="this.devicetype.devicetype === 'tablet' " name="cilTablet"  title='Tablet'></CIcon> 
        <CIcon size="xl" v-if="this.devicetype.devicetype === 'tv' " name="cilTv"  title='Smart TV'></CIcon> 
        <CIcon size="xl" v-if="this.devicetype.devicetype === 'speaker' " name="cilSpeaker"  title='Internet connected speaker system'></CIcon> 
        <CIcon size="xl" v-if="this.devicetype.devicetype === 'laptop' " name="cilLaptop"  title='Laptop computer'></CIcon> 
        <CIcon size="xl" v-if="this.devicetype.devicetype === 'desktop' " name="cilMonitor"  title='Desktop computer'></CIcon> 
        <CIcon size="xl" v-if="this.devicetype.devicetype === 'printer' " name="cilPrint"  title='Internet connected printer'></CIcon> 
        <CIcon size="xl" v-if="this.devicetype.devicetype === 'watch' " name="cilWatch"  title='Smart watch'></CIcon> 
        <CIcon size="xl" v-if="this.devicetype.devicetype === 'other' " name="cilWifi"  title='Other wifi device'></CIcon> 
    </div>
</template>

<script>
export default {
  name: 'Devicetype',
  props: {
    devicetype: Object
  }
}
</script>
